export const downloadFile = async ({ user, rowItem, db }) => {
    const url = await db.download(`FlightTestCrew/${user.ID}/Files/${rowItem.File}`);
    if (!url) {
        return;
    }
    window.open(url, '_blank');
};

export const uploadFile = async ({ form, item, db}) => {
    form.setConfig({
        "title": "Upload File",
        "type": "push",
        "location": `FlightTestCrew/${item.ID}/Files`,
        "fields": [{
            "label": "File",
            "name": "File",
            "type": "file"
        }],
        async preSubmitHook({ files }) {
            for (const file of files) {
                await db.upload(`FlightTestCrew/${item.ID}/Files`, file[0]);
            };

            return {
                "Date": new Date().toISOString(),
                "File": files[0][0].name,
            };
        }
    });
    form.toggle();
};

export const deleteFile = async ({ form, user, rowItem, db }) => {
    form.setConfig({
        "title": "Delete File",
        "type": "delete",
        "location": `FlightTestCrew/${user.ID}/Files/${rowItem.ID}`,
        "description": `Are you sure you want to delete ${rowItem.File}?`,
        async postSubmitHook(data) {
            await db.remove(`FlightTestCrew/${user.ID}/Files/`, rowItem.File);
        }
    });

    form.toggle();
};
